import { DocumentServicesObject } from '@wix/document-services-types';
import { SdkEventHandlerService } from './SdkEventHandlerService';
import { EditorEventHandlersFactory } from './handlers';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';
import {
  EventListenerStrategy,
  getEventListenerStrategy,
} from './eventListenerStrategy';
import { AppRefreshService } from './services';
import { IExperimentsApiAdapter } from '../../utils/experimentsApiAdapter';

export const initSdkEventHandlerService = (
  strategy: EventListenerStrategy,
  documentServicesAPI: DocumentServicesObject,
  experimentsAPI: IExperimentsApiAdapter,
  platformApiMethods: PlatformApiMethods,
  appRefreshService: AppRefreshService,
) => {
  const { eventHandlers } = new EditorEventHandlersFactory(
    platformApiMethods,
    documentServicesAPI,
    experimentsAPI,
    appRefreshService,
  );

  const listenerMethod = getEventListenerStrategy(strategy);

  const service = SdkEventHandlerService(
    listenerMethod,
    eventHandlers,
    documentServicesAPI,
    platformApiMethods,
  );

  try {
    service.initializeListenerHandlers();
  } catch (e) {
    console.error('Failed to initialize sdk event handler service', e);
  }
};
